import { render, staticRenderFns } from "./RcWidgetLiveResultsAlpha2.vue?vue&type=template&id=41af23b4&"
import script from "./RcWidgetLiveResultsAlpha2.vue?vue&type=script&lang=js&"
export * from "./RcWidgetLiveResultsAlpha2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports